module.exports = __webpack_public_path__ + "static/media/imageskybanner2.6410d18b.jpeg";